import {
	accountNumberFieldName,
	bankAccountFieldName,
	bankFieldName,
	cardHolderNameFieldName,
	cardNumberFieldName,
	cardTypeFieldName,
	cvvFieldName,
	routingNumberFieldName,
} from "components/pages/paymentMethods/paymentMethodForm/paymentMethodConstants";
import { PaymentTypes } from "types";

const applicationSummaryPaymentMethodMapper = ({
	softwareOptionsBillingInformationForm,
}: {
	softwareOptionsBillingInformationForm: { [key: string]: any };
}) => {
	// Software Info Billing Information
	const paymentMethodData =
		softwareOptionsBillingInformationForm?.paymentMethodData;

	const paymentMethod = {
		ach:
			PaymentTypes.ach.name ===
			softwareOptionsBillingInformationForm?.paymentType
				? {
						account_number:
							paymentMethodData?.[accountNumberFieldName],
						bank_account_name:
							paymentMethodData?.[bankAccountFieldName],
						bank_name: paymentMethodData?.[bankFieldName],
						routing_number:
							paymentMethodData?.[routingNumberFieldName]?.value,
				  }
				: null,
		// Credit card is not supported in RiseCRM anymore (SUP-1162)
		credit_card:
			PaymentTypes.creditCard.name ===
			softwareOptionsBillingInformationForm?.paymentType
				? {
						network: paymentMethodData?.[cardTypeFieldName],
						holder_name:
							paymentMethodData?.[cardHolderNameFieldName],
						number: paymentMethodData?.[cardNumberFieldName],
						expiration_month: paymentMethodData?.month,
						expiration_year: paymentMethodData?.year,
						cvv: paymentMethodData?.[cvvFieldName],
				  }
				: null,
		id: paymentMethodData?.id,
		is_active: true,
		payee_first_name: null,
		payee_last_name: null,
		payment_type: softwareOptionsBillingInformationForm?.paymentType,
	};

	// In form data stores only selected payment method data, so no need to have an extra data
	return { count: 1, items: [paymentMethod] };
};

export { applicationSummaryPaymentMethodMapper };
